import axios from 'axios';
import { IAuthService, AuthResponse } from '../interfaces/IAuth';
import { API_URL } from '../global/global';

class AuthService implements IAuthService {
  private baseURL = `${API_URL}/auth`;

  async login(username: string, password: string): Promise<string | null> {
    try {
      const response = await axios.post<AuthResponse>(`${this.baseURL}/login`, {
        username,
        password
      });

      if (response.data.success && response.data.token) {
        const expirationTime = Date.now() + (12 * 60 * 60 * 1000); // 12 horas
        localStorage.setItem('dhl_token', response.data.token);
        localStorage.setItem('dhl_username', username);
        localStorage.setItem('dhl_token_expiration', expirationTime.toString());
        return response.data.token;
      }
      return null;
    } catch (error) {
      console.error('Login error:', error);
      return null;
    }
  }

  async validateToken(token: string): Promise<boolean> {
    try {
      const response = await axios.post(`${this.baseURL}/validate`, { token });
      return response.data.valid;
    } catch (error) {
      return false;
    }
  }

  logout(): void {
    localStorage.removeItem('dhl_token');
    localStorage.removeItem('dhl_username');
    localStorage.removeItem('dhl_token_expiration');
  }

  isTokenExpired(): boolean {
    const expiration = localStorage.getItem('dhl_token_expiration');
    if (!expiration) return true;
    return Date.now() > parseInt(expiration);
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return token !== null && !this.isTokenExpired();
  }

  getToken(): string | null {
    return localStorage.getItem('dhl_token');
  }

  getUsername(): string | null {
    return localStorage.getItem('dhl_username');
  }

  getUserDisplayName(): string {
    const username = this.getUsername();
    if (!username) return 'Usuario';
    
    // Convertir "alan.vazquez" a "Alan Vazquez"
    return username
      .split('.')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
}

export default new AuthService();
